module.exports = __webpack_public_path__ + "static/media/logo_small_transparent.dbb0d8d7.png";